
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import SaberWeightsContent from "./Components/SaberWeightsContent.vue";

export default defineComponent({
  name: "SaberWeightsView",
  components: { BreadCrumb, SaberWeightsContent },
});
